import { CaretDownFilled, CaretUpFilled } from '@ant-design/icons'
import ShipmentCalculatedValue from '../../../../components/shipment-calculated-value/shipment-calculated-value'
import {
    getShipmentDisplayCalculated,
    isShipmentCalculatedOnActual,
} from '../../../../helpers/entities/shipment/get-shipment-display-calculated'
import {
    getShipmentActualMaterialLengthKm,
    hasShipmentMaterialConsumptions,
} from '../../../../helpers/entities/shipment/get-shipment-material-consumptions'
import { onCellStandard } from '../../helpers/helpers'
import { DataSourceItem } from '../../shipments-page'
import type { ShipmentColumn } from '../../types/column-types'
import { green, red } from '@ant-design/colors'

function formatLengthKm(lengthKm: number) {
    return Math.round(lengthKm * 1000) / 1000
}

export const calculatedMaterialLengthColumn: ShipmentColumn = {
    dataIndex: ['calculated', 'materialLength'],
    title: 'Длина роля',
    width: 50,
    onCell: onCellStandard,
    render: (_v, r: DataSourceItem) => {
        let value: number

        if (isShipmentCalculatedOnActual(r)) {
            value = formatLengthKm(getShipmentDisplayCalculated(r)?.materialLength || 0)
        } else if (hasShipmentMaterialConsumptions(r)) {
            value = formatLengthKm(getShipmentActualMaterialLengthKm(r) ?? 0)
        } else {
            value = formatLengthKm(getShipmentDisplayCalculated(r)?.materialLength || 0)
        }

        const content = (
            <ShipmentCalculatedValue isActual>
                {value}
            </ShipmentCalculatedValue>
        )

        if (r.shipmentType !== 'label' || !isShipmentCalculatedOnActual(r)) {
            return content
        }

        const planned = r.calculated?.materialLength ?? 0
        const actual = r.calculatedOnActual?.materialLength ?? 0
        const difference = actual - planned

        if (difference === 0) return content

        return (
            <>
                {content}{' '}
                {difference < 0 ? <CaretDownFilled style={{ color: green[5] }} /> : <CaretUpFilled style={{ color: red[5] }} />}
            </>
        )
    }
}